import { StudyStoreState } from '@/enums/study-store-state';
import { IStudyStoreState } from '@/interfaces/store/study-store/study-store.state.interface';
import { reactive } from 'vue';

export const studyStoreState = (
	studyId: number,
	storeInitState: StudyStoreState,
): IStudyStoreState => {
	return reactive({
		fit: null,
		storeState: storeInitState,
		studyId,
		studyTitle: null,
		referralLink: null,
		isPremium: null,
		universityTitle: null,
		organizationId: null,
	});
};
